import type { IconSvgObject } from './types';

const LinkBackwardIcon: IconSvgObject = [
  ["path", { d: "M11 8.5H10.5V4L3 11.5L10.5 19V14.5C17 14.5 21 20 21 20V18.5C21 12.9772 16.5228 8.5 11 8.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default LinkBackwardIcon;
